/**
 * 统一图标导出 (M36)
 *
 * Lucide icons (lucide-react) — 一致 stroke=2、线条干净
 * 用法:
 *   import { Icon } from '../icons';
 *   <Icon.Account size={16} />
 *
 * 与 AntD icons 共存:
 *   - 新代码用 Icon.* (lucide)
 *   - 老代码 @ant-design/icons 不动
 *   - 渐进式替换
 */
import {
  AlertCircle,
  AppWindow,
  Archive,
  ArrowLeft,
  ArrowRight,
  AtSign,
  BadgeDollarSign,
  Bell,
  Boxes,
  Briefcase,
  Building,
  Building2,
  Calendar,
  ChartNoAxesCombined,
  Check,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsRight,
  Cloud,
  CloudUpload,
  Database,
  Download,
  Edit,
  Eye,
  EyeOff,
  File,
  FileText,
  Filter,
  FolderKanban,
  Globe,
  History,
  Home,
  Inbox,
  Info,
  KeyRound,
  Layout,
  LayoutGrid,
  Link,
  ListChecks,
  Loader2,
  LogOut,
  Mail,
  MapPin,
  Menu as MenuIcon,
  MessageSquare,
  MoreHorizontal,
  Network,
  Package,
  PackageCheck,
  Pencil,
  Phone,
  Plus,
  RefreshCw,
  Save,
  Search,
  Settings,
  Settings2,
  Shield,
  ShieldCheck,
  ShoppingBag,
  SlidersHorizontal,
  Sparkles,
  Star,
  Trash2,
  TrendingUp,
  Truck,
  User,
  UserCog,
  UserPlus,
  Users,
  Workflow,
  X,
  XCircle,
} from 'lucide-react';
import { AiAgentIcon } from './AiAgentIcon.js';

/** 业务实体图标（语义化别名） */
export const Icon = {
  // 实体
  Account: Building2, // 客户
  Contact: Users, // 联系人
  Lead: UserPlus, // 潜在客户
  Opportunity: Briefcase, // 商机
  Quote: FileText, // 报价单
  SalesOrder: ShoppingBag, // 销售订单
  Sinosure: Shield, // 中信保
  DeliveryProject: Package, // 交付项目
  AI: AiAgentIcon, // AI 助手
  // 导航与配置菜单
  AppCenter: AppWindow, // 应用中心
  Organization: Network, // 组织架构
  BusinessUnit: Building, // 企业组织
  UserManagement: UserCog, // 用户管理
  RolePermission: ShieldCheck, // CRM角色权限
  FieldSecurity: KeyRound, // 字段安全配置
  AuditLog: FileText, // 全局审计日志
  NotificationHistory: Bell, // 通知历史
  IntegrationLog: Workflow, // 集成日志
  AgentConfig: Sparkles, // 智能体配置
  ApprovalConfig: CheckCircle2, // 审批配置
  ParameterConfig: SlidersHorizontal, // 参数配置
  Pricing: BadgeDollarSign, // 价格管理
  Delivery: Truck, // 交付管理
  ProjectDelivery: PackageCheck, // 项目交付
  SalesFunnel: ChartNoAxesCombined, // 销售漏斗
  ProductCatalog: Boxes, // 产品/应用清单
  Kanban: FolderKanban, // 看板/项目
  MyReports: FileText, // 我的报告
  ReportCoverage: ListChecks, // 提交覆盖率
  ReportIntelligence: Sparkles, // 经营洞察
  ReportBriefings: Calendar, // 周期简报
  ReportSettings: Settings2, // 报告设置
  History,
  Settings2,
  // 通用动作
  Add: Plus,
  Edit: Pencil,
  EditAlt: Edit,
  Delete: Trash2,
  Save,
  Search,
  Filter,
  Refresh: RefreshCw,
  Download,
  Upload: CloudUpload,
  Link,
  // 导航
  Home,
  Back: ArrowLeft,
  Forward: ArrowRight,
  Up: ChevronUp,
  Down: ChevronDown,
  Left: ChevronLeft,
  Right: ChevronRight,
  Next: ChevronsRight,
  More: MoreHorizontal,
  Menu: MenuIcon,
  // 状态
  Success: CheckCircle2,
  Error: XCircle,
  Warning: AlertCircle,
  Info,
  Loading: Loader2,
  Check,
  Close: X,
  // 通讯
  Mail,
  Phone,
  At: AtSign,
  Bell,
  Message: MessageSquare,
  // 数据
  Inbox,
  Archive,
  Database,
  Cloud,
  Network,
  // UI
  Eye,
  EyeOff,
  Calendar,
  MapPin,
  Star,
  Globe,
  Settings,
  Logout: LogOut,
  Grid: LayoutGrid,
  Layout,
  ListChecks,
  TrendingUp,
  ShoppingBag,
  File,
  User,
} as const;

// 重导出所有 lucide 名字（备选用）
export * from 'lucide-react';
